import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the VersionProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class VersionProvider {

  constructor(public http: HttpClient) {
    console.log('Hello VersionProvider Provider');
  }

}



// WEBPACK FOOTER //
// ./src/providers/version/version.ts